import { render, staticRenderFns } from "./DesiredField.vue?vue&type=template&id=23aeb23a&scoped=true&"
import script from "./DesiredField.vue?vue&type=script&lang=js&"
export * from "./DesiredField.vue?vue&type=script&lang=js&"
import style0 from "./DesiredField.vue?vue&type=style&index=0&id=23aeb23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aeb23a",
  null
  
)

export default component.exports